/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Voucher_LabelInputs */

const en_billing_voucher_label = /** @type {(inputs: Billing_Voucher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voucher code`)
};

const id_billing_voucher_label = /** @type {(inputs: Billing_Voucher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kode voucher`)
};

/**
* | output |
* | --- |
* | "Voucher code" |
*
* @param {Billing_Voucher_LabelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const billing_voucher_label = /** @type {((inputs?: Billing_Voucher_LabelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Voucher_LabelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_billing_voucher_label(inputs)
	return en_billing_voucher_label(inputs)
});